import * as React from "react";

import { hasValue } from "@core/utils";
import { IKlantcontactBevestiging } from "@klantondersteuning/client";
import { DownloadComponent } from "@klantondersteuning/shared";
import { usePageFlowContext } from "@shared/shared-generic-rekenmodule";

export interface ResultProps<T = unknown> {
  values: T;
  submitResult: IKlantcontactBevestiging;
  onStartOver: () => void;
  className?: string;
}

export const SubmitResult: React.FC<React.PropsWithChildren<ResultProps>> = (props) => {
  const { resetForm } = usePageFlowContext();
  const containerClassName = hasValue(props.className)
    ? `formulierpage-result ${props.className}--result`
    : "formulierpage-result";
  React.useEffect(() => {
    resetForm();
  }, []);
  return (
    <div className={containerClassName}>
      {props.children}

      <ResultButtons className={props.className}>
        {props.submitResult && props.submitResult.formulierSamenvatting && (
          <DownloadComponent
            base64String={props.submitResult.formulierSamenvatting.base64Inhoud}
            name={props.submitResult.formulierSamenvatting.bestandsnaam}
          />
        )}
      </ResultButtons>
    </div>
  );
};

export const ResultButtons: React.FunctionComponent<React.PropsWithChildren<{ className?: string }>> = (
  props
) => {
  const containerClassName = hasValue(props.className)
    ? `${props.className}--result-buttons`
    : "result-buttons";

  return <div className={containerClassName}>{props.children}</div>;
};
